import React, { useEffect, useRef } from 'react';
import { fmtDate } from '../../utils/format';

const ThreadView = ({ messages = [], currentUser, typing }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current; if (!el) return;
    el.scrollTop = el.scrollHeight;
  }, [messages.length, typing]);

  // Dedupe and stable sort by createdAt ascending
  const seen = new Set();
  const list = (messages || []).filter(m => {
    const id = m?._id || `${m.createdAt}-${m.bodyText || m.body}`;
    if (seen.has(id)) return false;
    seen.add(id); return true;
  }).sort((a,b)=> new Date(a.createdAt) - new Date(b.createdAt));

  return (
    <div className="thread" ref={ref}>
      {list.map(m => {
        const senderId = (m.sender && (m.sender._id || m.sender)) || m.userId;
        const isMine = String(senderId || '') === String(currentUser?._id || '');
        const isNote = m.channel === 'note' || m.internal;
        const baseRoleCls = isNote ? 'note' : (isMine ? 'agent' : 'customer');
        const alignCls = isMine ? 'msg--out' : 'msg--in';
        const key = m._id || `${m.createdAt}-${(m.bodyText||m.body||'').slice(0,20)}`;
        return (
          <div key={key} className={`msg ${baseRoleCls} ${alignCls}`}>
            <div className="msg__bubble">
              <div className="msg__body">{m.bodyText || m.body || ''}</div>
              <span className="msg__time">{fmtDate(m.createdAt)}</span>
            </div>
          </div>
        );
      })}
      {typing && <div className="typing">Customer is typing…</div>}
    </div>
  );
};

export default ThreadView;
